import {LitElement, html} from 'lit-element';
import {getScript, getRaiGlobalProperty, getPrivacyConsent, getUrlParameter} from '../../../../utilities/utils.js';
import {raiPlayerEvents} from 'RaiPlay/assets-src/js/webcomponents/src/rai-player/player-events';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

const unsubscribe$ = new Subject();
const trackEnqueue = window.Rai._trackEnqueue;

const libraryPath = (document.location.protocol.indexOf("https") != -1
? "https://79423.analytics.edgekey.net/"
: "http://79423.analytics.edgesuite.net/") + 'ma_library/javascript/javascript_malibrary.js';
const hls_libraryPath = '/common/assets/js/akamai/hlsjs_AkamaiMediaAnalytics.js';
const dash_libraryPath = '/common/assets/js/akamai/dashjs_AkamaiMediaAnalytics.js';
let playbackStarted = false;

export default class _Akamai extends LitElement {
    constructor(){
        super();
        this.pageInfo = undefined;
        this.useExplicitTracking=false;
        this.akamaiAnalytics=null;
        this.forceStandardTrack= false;
    }
    static get properties() {
        return {
            pageInfo: {type: Object},
            mediaInfo: {type: Object},
        };
    }
    shouldUpdate(_chg) {
        return false;
    }
    updated(){
        !!this.mediaInfo && !this.mediaLibraryLoaded && this.initMediaTrack();
    }
    render(){
        return html``;
    }
    firstUpdated(){
        this.forceStandardTrack=!!getUrlParameter('forceStandardTrack');
        getScript(libraryPath);
        // getScript(hls_libraryPath);
        // getScript(dash_libraryPath);        
        
        this.firstUpdate = true;
    }
    
    disconnectedCallback(){
        super.disconnectedCallback();
        unsubscribe$.next();
        unsubscribe$.complete();
    }

    initMediaTrack(){
        this.mediaLibraryLoaded = true;
        
        let events = raiPlayerEvents.media;
        this.handledEvents = [
            events.READY,
            events.PLAYBACK_STARTED,
            events.ADS.STARTED,
            events.PLAYING,
            events.PROGRAM_INFO_UPDATED,
            events.BUFFERING_STARTED,
            events.BUFFERING_END,
            events.ADS.COMPLETE,
            events.ADS.FIRST_QUARTILE,
            events.ADS.MIDPOINT,
            events.ADS.THIRD_QUARTILE,
            events.ENDED,
            events.DISPOSE,
            events.TECH_REF_READY,
            events.LOADMETADATA,

            events.ADS.SKIPPED,
            events.PAUSE,
            events.SEEK_START,
            events.SEEK_END,
        ];
        trackEnqueue.mediaQueue                                                                 /* media track */
            .pipe(
                filter(plEvent => this.handledEvents.includes(plEvent.type)),
                takeUntil(unsubscribe$)
            )
            .subscribe(plEvent => {
                try{this.trackMedia(plEvent.detail)}
                catch(e){console.error(e);}
            });
    }

    trackMedia(event){
        if(!event.eventData) throw "Missing player event data";
        let eventInfo = event.eventData;
        let events = raiPlayerEvents.media;
        
        let track_info = this.mediaInfo.track_info;
        let akamaiCallBack = () =>{
            return eventInfo.currentTime
        }
        let Raisso = getRaiGlobalProperty('Raisso');
        let ProfileManager = getRaiGlobalProperty('ProfileManager');
        let raiSsoUserObject = !!ProfileManager && ProfileManager.getUserProfile();
        if(eventInfo.eventName==events.TECH_REF_READY){
            // if(!!eventInfo.additionalData && !!eventInfo.additionalData.techRef && !this.forceStandardTrack){
            //     if(eventInfo.techType=='hls'){
            //         this.useExplicitTracking=false;
            //         this.akamaiAnalytics=new hlsjs_AkamaiMediaAnalytics("//ma688-r.analytics.edgekey.net/config/beacon-20535.xml");
                    
            //     }
            //     else if(eventInfo.techType=='dash'){
            //         this.useExplicitTracking=false;
            //         this.akamaiAnalytics=new dashjs_AkamaiMediaAnalytics("//ma688-r.analytics.edgekey.net/config/beacon-20535.xml");
            //     }
            //     this.akamaiAnalytics.setMediaPlayer(eventInfo.additionalData.techRef);
            // }else{
                this.useExplicitTracking=true;
                this.akamaiAnalytics=new JS_AkamaiMediaAnalytics("//ma688-r.analytics.edgekey.net/config/beacon-20535.xml");;
            // }            
            this.akamaiAnalytics.disableLocation();
            
        }
        if(eventInfo.eventName==events.LOADMETADATA){            
            /* Custom dimensions */
            this.akamaiAnalytics.setData("title", track_info.title);
            this.akamaiAnalytics.setData("eventName", track_info.episode_title);
            this.akamaiAnalytics.setData("eventName", track_info.episode_title);
            this.akamaiAnalytics.setData("device", navigator.userAgent);
            this.akamaiAnalytics.setData("deliveryType", this.mediaInfo.is_live ? "T" : "O");
            this.akamaiAnalytics.setData("cdn", "Akamai");
            

            if(this.useExplicitTracking){
                this.akamaiAnalytics.setStreamURL(eventInfo.currentSrc, true);
                this.akamaiAnalytics.setStreamDuration(eventInfo.mediaDuration);
                this.akamaiAnalytics.handleSessionInit(akamaiCallBack);
            }
        }
        if(eventInfo.eventName==events.PLAYBACK_STARTED){
            playbackStarted=true;
        }
        if(playbackStarted && !!this.akamaiAnalytics){
            if(this.useExplicitTracking){
                switch (eventInfo.eventName) {
                    case events.PLAYING:
                        this.akamaiAnalytics.handlePlaying();
                        break;
                    case events.PAUSE:
                        this.akamaiAnalytics.handlePause();
                        break;
                    case events.SEEK_START:
                        this.akamaiAnalytics.handleSeekStart();
                        break;
                    case events.SEEK_END:
                        this.akamaiAnalytics.handleSeekEnd();
                        break;
                    case events.BUFFERING_STARTED:
                        this.akamaiAnalytics.handleBufferStart();
                        break;
                    case events.BUFFERING_END:
                        this.akamaiAnalytics.handleBufferEnd();
                        break;
                    case events.ENDED:
                    case events.DISPOSE:
                        console.log("dispose,end");
                        this.akamaiAnalytics.handlePlayEnd("Play.End.Detected");
                        break;
                }
            }
            switch (eventInfo.eventName) {
                case events.ADS.STARTED:
                    this.akamaiAnalytics.handleAdLoaded({
                        "adTitle": eventInfo.mediaType + ' ' + eventInfo.sequenceIndex,
                        "adDuration": Math.round(eventInfo.mediaDuration),
                        "adServer": "dfp",
                        "id": eventInfo.creativeId
                    });
                    this.akamaiAnalytics.handleAdStarted();
                    break;
                case events.ADS.SKIPPED:
                    this.akamaiAnalytics.handleAdSkipped();
                    break;
                case events.ADS.FIRST_QUARTILE:
                    this.akamaiAnalytics.handleAdFirstQuartile();
                    break;
                case events.ADS.MIDPOINT:
                    this.akamaiAnalytics.handleAdMidPoint();
                    break;
                case events.ADS.THIRD_QUARTILE:
                    this.akamaiAnalytics.handleAdThirdQuartile();
                    break;
                case events.ADS.COMPLETE:
                    this.akamaiAnalytics.handleAdComplete();
                    break;
            }
        }
    }
}
